import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  infoHeader: {
    display: "flex",
    alignItems: "center",
    "& h3": {
      margin: "0 8px",
    },
  },
  buttonHeader: {
    alignSelf: "center",
    marginLeft: 12,
  },
  customHeader: {
    display: "flex",
    marginLeft: 18,
    alignItems: "center",
    justifyContent: "flex-end",
    flex: 1,
  },
  calendar: {
    display: "flex",
    padding: "0 18px",
    alignItems: "center",
    borderLeft: "1px solid #DFE1E6",
    borderRight: "1px solid #DFE1E6",
    color: "#7A869A",
    fontSize: 14,
    marginRight: 18,
  },
  calendarIcon: {
    width: 18,
    marginRight: 8,
  },
  badge: {
    marginRight: 12,
    "& span": {
      fontSize: 14,
      height: 36.5,
      padding: "0 12px",
    },
  },
  tabheader: {
    borderBottom: `1px solid ${theme.color.gray2}`,
  },
  stepContainer: {
    maxHeight: "85%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderColor: "white",
    borderStyle: "solid",
    borderWidth: 12,
    overflowY: "auto",
    flex: 1,
    marginBottom: 24,
  },
  tabContents: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderColor: "white",
    borderStyle: "solid",
    borderWidth: 12,
    overflowY: "auto",
    flex: 1,
    "& td.MuiTableCell-body:first-child": {
      position: "sticky",
      left: 0,
      backgroundColor: "white",
    },
    "& tr:hover td.MuiTableCell-body:first-child": {
      backgroundColor: "#F4F5F7",
    },
    "& .MuiTableContainer-root": {
      boxShadow: "unset",
      padding: 0,
      display: "flex",
      alignItems: "flex-start",
      maxHeight: "80vh",
    },
    "& .MuiIconButton-label": {
      transform: "scale(0.6) !important",
    },
    "& thead": {
      position: "sticky",
      top: 0,
      zIndex: 2,
      "& th.MuiTableCell-head:first-child": {
        position: "sticky",
        left: 0,
        backgroundColor: "#F4F5F7",
        zIndex: 1,
      },
    },
  },
  attachmentTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& h3": {
      margin: "0 8px",
    },
  },
  table: {
    minHeight: "initial !important",
  },
  orderRecapTable: {
    marginTop: theme.spacing(4),
  },
  products: {
    boxShadow: "none",
    padding: 0,
  },
  addMaterialBtn: {
    marginTop: `${theme.spacing(4)}px !important`,
  },
  customCell: {
    padding: "0 !important",
  },
  textField: {
    flex: 1,
    margin: "12px 0!important",
    pointerEvents: "none !important",
  },
  timeline: {},
  "@media only screen and  (max-width: 1232px)": {
    timeline: {
      overflow: "auto",
    },
  },
  CreateEdbPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
  },
  titleCustom: {
    marginTop: 15,
    marginBottom: 15,
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  headTextRefs: {
    fontSize: 13,
    margin: 0,
    textDecoration: "none",
    color: theme.color.blueLight,
    fontWeight: "700",
  },
  headTextRefsSeparator: {
    color: theme.color.gray5,
    fontSize: 13,
    fontWeight: 400,
    marginLeft: 10,
    marginRight: 10,
    position: "relative",
    top: 2,
  },
  numberTextField: {
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
      {
        display: "none",
      },
  },
  navigationStep: {
    marginTop: 18,
    marginBottom: 18,
    display: "flex",
    justifyContent: "space-between",
  },
  iOrdersAndReceptions: {
    display: "flex",
    justifyContent: "space-between",
  },
  blueIcon: {
    color: `${theme.color.blueLight} !important`,
    // Add the disabled color
    "&.Mui-disabled": {
      color: `${theme.color.gray3} !important`,
      pointerEvents: "none",
      cursor: "unset",
      "&:hover, &:focus, &:active": {
        background: "#ccc",
      },
    },
  },
  quantityEditRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "100%",
    maxWidth: "100%",
  },
  quantityPickerWrapper: {
    flex: 1,
    minWidth: 0,
  },
  quantityPicker: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
  },
  resetQtyButton: {
    padding: "4px !important",
  },
}));
